import { render, staticRenderFns } from "./chonburi-hub.vue?vue&type=template&id=327719f6&scoped=true"
import script from "./chonburi-hub.vue?vue&type=script&lang=js"
export * from "./chonburi-hub.vue?vue&type=script&lang=js"
import style0 from "./chonburi-hub.vue?vue&type=style&index=0&id=327719f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327719f6",
  null
  
)

export default component.exports